module.exports = __webpack_public_path__ + "static/media/v_commerce_v2_840x520.bbdb7579.jpg";